module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921131151_T.c6a54782.jpg";